import getMeta from '@atlassian/jira-get-meta';
import transformSubProducts from '../transform-sub-products/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => transformSubProducts(getMeta('ajs-application-key'));
